var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.863,
    height: 82.115,
    viewBox: "0 0 190.863 82.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-95.558 -8.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M156.3,39.715c-.33,0-.658.009-.984.025a19.458,19.458,0,0,0-15.251-14.382l11-10.785-6.5-6.5L128.1,24.443H97.464v8.075h22.515L104.866,47.545l-.224.224h12.729l.161.771,0,.008h.006a19.451,19.451,0,0,0,8.2,12.015,10.877,10.877,0,1,1-21.153-4.721H95.84a19.4,19.4,0,0,0,37.984,7.8,19.485,19.485,0,0,0,2.668.188c.33,0,.658-.009.984-.024A19.4,19.4,0,1,0,156.3,39.715Zm-19.855,15.9A11.157,11.157,0,1,1,147.6,44.463,11.157,11.157,0,0,1,136.447,55.62ZM156.3,70A10.9,10.9,0,0,1,145.691,61.5a19.466,19.466,0,0,0,9.819-13.233c.261-.019.525-.032.792-.032A10.878,10.878,0,0,1,156.3,70Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(179.615 39.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M301.4,79.939a14.2,14.2,0,0,1,4.687.614c2.4.837,5.134,3.4,5.134,9.1a13.62,13.62,0,0,1-.056,1.507c-.056.781-.223,5.245-3.683,6.752a7.014,7.014,0,0,1-1.228.335,5.911,5.911,0,0,1,3.013,1.172c1.507,1.116,2.958,3.683,2.958,8.035,0,1.172,0,5.3-2.455,8.594a8.1,8.1,0,0,1-3.181,2.511c-1.563.669-3.181.837-6.473.893H288.68V79.939Zm-5.58,16.126h2.958a8.036,8.036,0,0,0,2.511-.279c1.618-.614,2.623-2.12,2.623-5.468,0-1.785-.335-3.906-2.176-4.631a5.736,5.736,0,0,0-2.344-.335h-3.571Zm.056,17.857h3.571a6.382,6.382,0,0,0,2.9-.5c1.4-.726,2.344-2.511,2.344-5.747,0-3.571-.949-5.245-2.735-5.915a6.368,6.368,0,0,0-2.51-.335h-3.571Z",
    transform: "translate(-288.68 -79.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M354.03,102.5l3.962,25.892L362.01,102.5h6.975l-7.2,32.086c-.948,4.018-1.562,6.249-3.125,7.589-1.284,1.172-3.18,1.283-4.855,1.339h-5.022l.056-5.356H351.8a2.282,2.282,0,0,0,1.841-.558,1.657,1.657,0,0,0,.447-1.116,3.786,3.786,0,0,0-.112-.781l-7.087-33.2Z",
    transform: "translate(-321.553 -92.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M409.766,83.913V92h3.013v4.967h-2.958v17.521a4.054,4.054,0,0,0,.168,1.451c.447.893,1.786.725,2.846.725l-.056,5.358c-1.06,0-2.121.055-3.18,0-.279,0-3.516.111-5.078-1.116-1.451-1.116-1.506-2.958-1.618-4.353V96.971h-2.678V92h2.734V83.913Z",
    transform: "translate(-351.674 -82.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M455.155,117.208l-13.671.056c.056,1.395.056,4.687.279,6.026.112.893.39,3.4,3.348,3.4,3.292,0,3.292-3.4,3.348-5.748h6.584a25.473,25.473,0,0,1-.168,2.957c-.558,4.185-2.4,5.8-4.129,6.7a11.853,11.853,0,0,1-5.58,1.227c-1.227,0-6.7.056-9.1-4.353-1.283-2.4-1.618-5.691-1.618-11.383a57.777,57.777,0,0,1,.279-6.25c.334-3.459,1.227-5.078,2.343-6.305,1.34-1.506,3.627-2.958,8.091-2.958,4.8,0,7.031,1.618,8.259,3.516,1.73,2.679,1.73,6.361,1.73,9.319Zm-6.752-4.8v-.949a15.7,15.7,0,0,0-.056-1.618c0-.726.112-4.129-3.237-4.129a3.031,3.031,0,0,0-2.511.949c-1.116,1.172-1.172,2.734-1.172,5.747Z",
    transform: "translate(-371.005 -91.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M502.046,110.568a12.159,12.159,0,0,0-.056-1.451c-.056-.893-.279-3.515-3.292-3.515a3.218,3.218,0,0,0-1.283.223,2.538,2.538,0,0,0-1.618,2.455,2.956,2.956,0,0,0,.39,1.451c.614,1.283,2.567,2.4,3.683,3.125.949.614,1.9,1.284,2.9,1.953a29.924,29.924,0,0,1,2.679,1.953,8.306,8.306,0,0,1,3.18,6.7,11.267,11.267,0,0,1-.5,3.237c-1.842,5.413-8.315,5.189-9.486,5.189-4.576,0-6.752-1.506-7.979-3.292-1.73-2.511-1.674-5.3-1.618-8.2h6.194c0,.781,0,1.506.056,2.288.056.949,0,4.185,3.571,4.185,1.73,0,3.125-1,3.069-2.846,0-2.064-1.785-2.958-3.18-3.85-.781-.558-1.618-1.06-2.4-1.618a26.1,26.1,0,0,1-4.8-3.795,7.948,7.948,0,0,1-2.232-5.915,9.063,9.063,0,0,1,.67-3.571c1.06-2.511,3.515-4.688,9.151-4.688a14.068,14.068,0,0,1,3.627.5,6.81,6.81,0,0,1,4.967,4.855,16.331,16.331,0,0,1,.446,4.632Z",
    transform: "translate(-401.824 -91.595)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.e2ec42a78dcccd5918b30c7d5d6c107e.svg";
export { ForwardRef as ReactComponent };